import { ProcessableRtes } from '../C3ServerlessBundle';

const URL_PATTERNS = [
  {
    nonprod: new RegExp(/\.web(t|e|d)\./),
    prod: new RegExp(/\.web\./),
  },
];

namespace NoneProcessableRte {
  export type NoneLiteralType = 'NONE';
  export const NoneLiteral: NoneLiteralType = 'NONE';
}

type NullableProcessableRte =
  | ProcessableRtes.ProdProcessableRte
  | ProcessableRtes.NonprodProcessableRte
  | NoneProcessableRte.NoneLiteralType;

export default class RteValidator {
  static validateRte(rte: string = ''): boolean {
    const rteBasedOnScript = RteValidator.determineRteByBundleScript();
    const isLocal = RteValidator.checkForLocalWorkspace();
    const result = isLocal || rte === rteBasedOnScript;

    if (!result) {
      console.error('Invalid config - Mismatch RTEs bundle will NOT process concerns');
    }

    return result;
  }

  private static checkForLocalWorkspace(): boolean {
    const hostname = document.location.hostname;
    const LOCAL_PATTERN = new RegExp(/^localhost.vanguard.com$/i);
    const CODER_PATTERN = new RegExp(/coder\.opst\.c1\.vanguard.com$/i);
    const isLocal = LOCAL_PATTERN.test(hostname);
    const isCoder = CODER_PATTERN.test(hostname);
    return isLocal || isCoder;
  }

  private static checkMatchRteUrlPatterns(hostname: string): NullableProcessableRte {
    const rteFromPatternMatch: NullableProcessableRte[] = [];
    URL_PATTERNS.forEach((pattern) => {
      const isNonProd = pattern.nonprod.test(hostname);
      const isProd = pattern.prod.test(hostname);
      const result =
        isNonProd === isProd
          ? NoneProcessableRte.NoneLiteral
          : isNonProd
            ? ProcessableRtes.NonprodProcessableRte
            : ProcessableRtes.ProdProcessableRte;
      rteFromPatternMatch.push(result);
    });
    const result = rteFromPatternMatch.filter((rteResults) => rteResults !== NoneProcessableRte.NoneLiteral);
    const allNonProd = (element) => element === ProcessableRtes.ProdProcessableRte;
    return result.length === 0
      ? NoneProcessableRte.NoneLiteral
      : result.every(allNonProd)
        ? ProcessableRtes.ProdProcessableRte
        : ProcessableRtes.NonprodProcessableRte;
  }

  static determineRteByBundleScript(): NullableProcessableRte {
    const bundleScript = document.querySelector('script[src*=vg-ccc-serverless]') as Element;
    return RteValidator.checkMatchRteUrlPatterns(bundleScript.getAttribute('src') as string);
  }
}
